<template>
  <div class="md-card">
    <div class="md-card-content">
      <validation-form @on-submit="manageTask">
        <div class="md-layout">
          <div class="md-layout-item md-size-70">
            <validation-field
              :validations="{ required: true }"
              name="Project name"
            >
              <label>{{ $t("task_management.project_name") }}</label>
              <md-input
                :disabled="isDisabled"
                required
                v-model.trim="mainTask.project_name"
              ></md-input>
            </validation-field>
          </div>
          <div class="md-layout-item md-size-30">
            <validation-field
              style="margin-bottom: 0px !important"
              :validations="{ required: true }"
              name="Owner"
              type="autocomplete"
            >
              <template #default="{ errors }">
                <isis-autocomplete
                  :isDisabled="isDisabled"
                  v-model="owner.value"
                  :value.sync="mainTask.owner_id_no_sql"
                  :options.sync="owner.ownerList"
                  :refetchOptions="fetchOwner"
                  search-key="search_key"
                  :fields="{ text: 'name', value: 'id' }"
                  label="task_management.owner"
                  :class="{ 'md-invalid': !!errors.length }"
                  required
                  fetchOnOpen
                >
                  <span class="md-error" style="top:36px">{{ errors[0] }}</span>
                </isis-autocomplete>
              </template>
            </validation-field>
          </div>
          <div class="md-layout-item md-size-70">
            <md-field>
              <label>{{ $t("task_management.short_description") }}</label>
              <md-input
                v-model.trim="mainTask.short_description"
                :disabled="isDisabled"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-30">
            <validation-field :validations="{ required: true }" name="status">
              <label>{{ $t("common.status") }}</label>
              <md-select
                v-model="mainTask.task_status_id"
                required
                :disabled="isDisabled"
              >
                <md-option
                  v-for="status in taskStatus"
                  :key="status.name"
                  :value="status.id"
                >
                  {{ generateStatus(status.name) }}
                </md-option>
              </md-select>
            </validation-field>
          </div>
          <div
            class="md-layout-item md-size-100 flex text-center mt-4"
            v-if="
              (userInfo.id === mainTaskOwner && mode === 'edit') ||
                mode === 'add' ||
                roleActive === 'Admin' ||
                roleActive === 'Principal'
            "
          >
            <md-button class="md-raised m-2" @click="goToPreviousPage">{{
              $t("common.cancel")
            }}</md-button>
            <md-button class="md-success m-2" type="submit">
              {{
                mode === "add"
                  ? $t("common.add_new")
                  : $t("task_management.update_main_task")
              }}</md-button
            >
          </div>
          <div class="md-layout-item md-size-100 md-layout">
            <div
              class="md-layout-item md-size-100 flex justify-between p-0 my-4"
              v-if="mode === 'edit'"
            >
              <p class="subtitle">{{ $t("task_management.list_subtask") }}</p>
              <md-button
                class="md-success"
                @click="$modal.show('SubtaskModal')"
                v-if="
                  mode === 'edit' &&
                    $can(TaskManagement.actions.add, TaskManagement.subject)
                "
                >{{ $t("task_management.create_subtask") }}</md-button
              >
            </div>
            <div
              class="md-layout-item md-size-100 p-0 max-h-[500px] overflow-y-auto border-t border-b"
              v-if="mode === 'edit'"
            >
              <SubTaskTable
                v-if="hasSubtask"
                :table-data="tableData"
                :table-header="tableHeader"
                @reloadData="fetchMainTask"
              ></SubTaskTable>
            </div>
          </div>
        </div>
      </validation-form>
      <div class="md-layout" v-if="mode === 'edit'">
        <div class="md-layout-item md-size-100">
          <Comment taskType="main-task" :taskId="taskId"></Comment>
        </div>
      </div>
    </div>
    <CommonModal
      width="80%"
      height="auto"
      name="SubtaskModal"
      :title="$t('task_management.add_new_subtask')"
      :hideFooter="true"
    >
      <template #modal-body>
        <SubtaskForm
          :subtaskData="subtaskData"
          mode="add"
          type="sub-task"
          :mainTaskId="taskId"
          :owner-id="mainTask.owner_id_no_sql"
          @addSubtaskSuccessfully="addSubtaskSuccessfully"
        >
        </SubtaskForm>
      </template>
    </CommonModal>
  </div>
</template>
<script>
import CommonModal from "@/components/Base/CommonModal";
import { hasHistory, getId } from "@/helpers/utils";
import SubTaskTable from "./SubTaskTable";
import { service_names } from "@/constants/Services";
import { mapGetters } from "vuex";
import SubtaskForm from "./SubtaskForm";
import { TaskManagement } from "@/constants/Permissions";
import Comment from "./Comment";
import { convertDateFromServer } from "@/helpers/datetime-helper";
import { generateStatus } from "../../../helpers/text-helper";

export default {
  props: ["mode"],
  components: {
    SubTaskTable,
    CommonModal,
    SubtaskForm,
    Comment
  },
  data() {
    const roleActive = localStorage.getItem("roleActive");
    return {
      generateStatus,
      roleActive,
      subtaskData: {},
      TaskManagement,
      owner: {
        value: "",
        ownerList: []
      },
      mainTask: {
        project_name: "",
        short_description: "",
        owner_id_no_sql: "",
        type: "main-task",
        task_status_id: ""
      },
      tableHeader: [
        "common.no_number",
        "task_management.task_name",
        "task_management.assignee",
        "task_management.reviewer",
        "common.status",
        "task_management.created_time",
        "task_management.deadline",
        "common.action"
      ],
      tableData: [],
      mainTaskOwner: "",
      hasSubtask: false,
      taskStatus: []
    };
  },
  created() {
    let initData = async () => {
      await this.fetchStatus();
      if (this.mode === "add" && this.roleActive !== "Teacher") {
        this.owner.value = this.userInfo.full_name;
        this.mainTask.owner_id_no_sql = this.userInfo._id;
      }
      if (this.mode === "edit") {
        this.fetchMainTask();
      }
    };
    initData();
  },
  computed: {
    ...mapGetters("user", { userInfo: "info" }),
    taskId() {
      return this.$route.params.id;
    },
    isDisabled() {
      return (
        getId(this.userInfo) !== this.mainTaskOwner &&
        this.mode === "edit" &&
        this.roleActive !== "Admin" &&
        this.roleActive !== "Principal"
      );
    }
  },
  methods: {
    fetchStatus() {
      return this.$axios
        .get(`${service_names.school}/task-status`)
        .then(res => {
          this.taskStatus = res.data.data;
          this.mainTask.task_status_id = getId(
            this.taskStatus.find(item => item.name === "assigned")
          );
        });
    },
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    },
    manageTask() {
      this.$emit("manageTask", this.mainTask, this.taskId);
    },
    addSubtaskSuccessfully() {
      this.$modal.hide("SubtaskModal");
      this.fetchMainTask();
    },
    fetchOwner(param) {
      return this.$axios
        .get(
          `${service_names.school}/task-managements/owner`,
          param,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(res => {
          this.owner.ownerList = res.data.data.map(item => ({
            id: getId(item),
            name: item.full_name + " - " + item.staff_code
          }));
        });
    },
    fetchMainTask() {
      this.hasSubtask = false;
      this.$axios
        .get(`${service_names.school}/main-task/${this.taskId}`)
        .then(res => {
          this.mainTaskOwner = res.data.owner_id_no_sql;
          this.mainTask.owner_id_no_sql = res.data.owner_id_no_sql;
          this.mainTask.project_name = res.data.project_name;
          this.mainTask.short_description = res.data.short_description;
          this.mainTask.task_status_id = res.data.task_status_id;
          this.owner.value = res.data.owner_main_tasks
            ? `${res.data.owner_main_tasks?.full_name || ""} - ${res.data
                .owner_main_tasks?.staff_code || ""}`
            : "";
          this.tableData = res.data.subtasks.map(item => ({
            ...item,
            taskName: item.task_name,
            assignee: item.assignee_sub_tasks?.full_name,
            reviewer: item.reviewer_sub_tasks?.full_name,
            status: item.task_status_id,
            createTime: convertDateFromServer(item.created_at, "date"),
            deadLine: convertDateFromServer(item.deadline, "date")
          }));
          this.hasSubtask = true;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.header-title {
  font-weight: 500;
  font-size: 26px;
  line-height: 36px;
  letter-spacing: 0.18px;
  color: #1b1f22;
  cursor: pointer;
}
.subtitle {
  padding-top: 24px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #242424;
}
</style>
